import {h, render} from 'vue'
import IncomingCallNotification from '~/components/IncomingCallNotification.vue'

export default defineNuxtPlugin(nuxtApp => {
    if (!nuxtApp.$conf.public.B2B.handlePhoneCalls) return

    let eventSource

    connect()

    EventBus.$on('B2B_AUTH_EVENT', connect)
    EventBus.$on('RESET', disconnect)

    function connect() {
        if (eventSource || !authStore.isTO1) return
        eventSource = new EventSource('/proxy/phone-calls')
        eventSource.onmessage = event => {
            if (event.data !== 'ping') show({phone: event.data})
        }
    }

    function disconnect() {
        eventSource?.close()
        eventSource = null
    }

    function createComponent(options: any) {
        const vNode = h(IncomingCallNotification, options)
        vNode.appContext = nuxtApp.vueApp._context
        const el = document.createElement('div')
        render(vNode, el)
        document.body.appendChild(el)
        return {vNode, el}
    }

    function show(options: any = {}) {
        const ctx: any = {}
        options.destroy = () => {
            render(null, el)
            ctx.el.remove()
            ctx.vNode = null
        }
        const {vNode, el} = createComponent(options)
        Object.assign(ctx, {vNode, el})
    }
})
